'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const ink = {
  '000': "#f8f8f7",
  '100': "#f3f2f2",
  '200': "#ebebeb",
  '300': "#d6d6d6",
  '400': "#c3c4c5",
  '500': "#a1a2a5",
  '600': "#797b81",
  '700': "#52555d",
  '800': "#32353f",
  '900': "#212530"
};

const blue = {
  '000': "#f2f5ff",
  '100': "#cdd9fa",
  '200': "#b5c1f6",
  '300': "#9ba7f1",
  '400': "#808cec",
  '500': "#5d69e6",
  '600': "#4957d2",
  '700': "#3a44b5",
  '800': "#252f98",
  '900': "#111a7c"
};

const green = {
  '000': "#e2f6f2",
  '100': "#b4e8de",
  '200': "#83daca",
  '300': "#4ecbb3",
  '400': "#00b490",
  '500': "#00a58a",
  '600': "#00917e",
  '700': "#007d73",
  '800': "#006969",
  '900': "#00565e"
};

const red = {
  '000': "#ffeef0",
  '100': "#ffd4d7",
  '200': "#ffb8bc",
  '300': "#fc9ea3",
  '400': "#fb7f86",
  '500': "#fa5a62",
  '600': "#e5465c",
  '700': "#ce3055",
  '800': "#b6194e",
  '900': "#9c0046"
};

const yellow = {
  '000': "#fff3af",
  '100': "#fed66a",
  '200': "#fbc85d",
  '300': "#35b45f",
  '400': "#d8a04c",
  '500': "#ca8d3c",
  '600': "#bc7b2c",
  '700': "#ad681e",
  '800': "#9e5610",
  '900': "#8f4402"
};

exports.default = {
  white: {
    normal: "#fff"
  },
  cloud: _extends({}, ink, {
    light: ink["000"],
    lightHover: ink["100"],
    lightActive: ink["200"],
    normal: ink["300"],
    normalHover: ink["400"],
    normalActive: ink["500"]
  }),
  ink: _extends({}, ink, {
    lighter: ink["300"],
    lighterHover: ink["400"], // unused in samba-ui
    lighterActive: ink["500"], // unused in samba-ui
    light: ink["700"],
    lightHover: ink["700"], // unused in samba-ui
    lightActive: ink["700"], // unused in samba-ui
    normal: ink["900"],
    normalHover: ink["900"], // unused in samba-ui
    normalActive: ink["900"], // unused in samba-ui
    dark: ink["900"]
  }),
  blue: _extends({}, blue, {
    light: blue["000"],
    lightHover: blue["100"],
    lightActive: blue["200"],
    normal: blue["600"],
    normalHover: blue["700"],
    normalActive: blue["800"],
    dark: blue["900"]
  }),
  green: _extends({}, green, {
    light: green["000"],
    lightHover: green["100"],
    lightActive: green["200"],
    normal: green["700"],
    normalHover: green["800"],
    normalActive: green["900"],
    dark: green["900"]
  }),
  red: _extends({}, red, {
    light: red["000"],
    lightHover: red["100"],
    lightActive: red["200"],
    normal: red["700"],
    normalHover: red["800"],
    normalActive: red["900"],
    dark: red["900"]
  }),
  orange: _extends({}, yellow, {
    light: yellow["000"],
    lightHover: yellow["100"],
    lightActive: yellow["200"],
    normal: yellow["600"],
    normalHover: yellow["700"],
    normalActive: yellow["800"],
    dark: yellow["900"]
  }),
  pink: {
    normal: "#fa5a62"
  },
  purple: {
    normal: "#574d9e"
  }
};